namespace Ir.Components.Filters.MultiSelectFilter {

    interface IMultiSelectFilterViewModel {
        filter: Filter;
        gridSettings: DevExpress.ui.dxDataGrid.Properties;
        gridComponent: DevExpress.ui.dxDataGrid;
        isWidgetFilter: boolean;

        sort: Function
    }

    export function getViewModel(this: IMultiSelectFilterViewModel, params: IFilterParameterVM, componentInfo) {
        let self = this;
        let updatingDataSource = false;
        this.filter = params.filter;
        this.isWidgetFilter = params.isWidgetFilter;

        this.sort = function (data: [] = null) {
            data.sort(function (v1, v2) {
                let field1 = null;
                let field2 = null;
                let type: DataTypeEnum = DataTypeEnum.STRING;
                if (self.filter.sortField() === DefinedFieldEnum.Bound) {
                    field1 = v1[0];
                    field2 = v2[0];
                    type = self.filter.boundFieldType();
                }
                else {
                    field1 = v1[1];
                    field2 = v2[1];
                    type = self.filter.displayFieldType();
                }

                if (field1 === undefined || field1 === null && field2 === undefined || field2 === null) {
                    return 0;
                }
                else if (field1 === undefined || field1 === null) {
                    return -1;
                }
                else if (field2 === undefined || field2 === null) {
                    return 1;
                }

                if (type === DataTypeEnum.NUMBER) {
                    field1 = parseFloat(field1);
                    field2 = parseFloat(field2);
                    return field1 - field2
                }

                return field1.localeCompare(field2);
            });
        };

        let showSubText = false;
        let columnName = "Value"
        if (this.filter.visibleFields() && this.filter.visibleFields().length > 0) {
            if (this.filter.visibleFields().length === 2 && this.filter.displayField() !== this.filter.boundField()) {
                showSubText = true;
            }

            columnName = this.filter.visibleFields().indexOf(DefinedFieldEnum.Display) !== -1 ? this.filter.displayDisplayFieldName() : this.filter.displayBoundFieldName();
        }
                
        let isMultiple = this.filter.filterEditorType() === FilterEditorTypeEnum.AutoComplete || this.filter.filterEditorType() === FilterEditorTypeEnum.MultiSelect;

        this.gridSettings = {
            disabled: this.filter.readOnly(),
            dataSource: this.filter.dataSource,
            keyExpr: "0",
            columnAutoWidth: true,
            columns: [{
                dataField: "0",
                visible: false
            }, {
                caption: columnName,
                dataField: "1",
                cellTemplate: function (container, options) {
                    let dbValue = `[${options.data[0]}]`;
                    if (!showSubText) {
                        dbValue = "";
                    }

                    $(`<span class="text">${options.data[1]}<small class="text-muted"> ${dbValue}</small></span>`).appendTo(container);
                }
            }],
            hoverStateEnabled: true,
            searchPanel: {
                visible: true,
                placeholder: "Search...",
                width: 212,
            },
            scrolling: {
                mode: "virtual"
            },
            height: this.isWidgetFilter ? "100%" : 250,
            width: "100%",
            selection: {
                mode: isMultiple ? "multiple" : "single",
                showCheckBoxesMode: "always"
            },
            selectedRowKeys: this.filter.multipleCondition as any,
            toolbar: {
                items: [{
                    location: 'after',
                    name: "searchPanel"
                }, {
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        icon: 'clearformat',
                        hint: 'Clear selected values',
                        onClick() {
                            if (self.filter.filterEditorType() === FilterEditorTypeEnum.ValuesCombo) {
                                self.filter.startCondition("");
                                self.filter.multipleCondition([]);
                            }
                            else {
                                self.filter.multipleCondition([]);
                            }

                            let dataSource = self.filter.dataSource();
                            self.sort(dataSource);
                            self.filter.dataSource(dataSource);

                            if (self.isWidgetFilter) {
                                self.filter.publish();
                            }
                        },
                    },
                }, {
                    location: 'after',
                    widget: 'dxButtonGroup',
                    visible: self.filter.showNullButton(),
                    options: {
                        items: [{
                            icon: 'ms ir-null-icon',
                            id: null,
                            hint: 'Include null value in options',
                        } as any],
                        keyExpr: 'id',
                        stylingMode: 'outlined',
                        selectedItemKeys: ko.computed(() => {
                            let data = self.filter.dataSource();
                            if (data && data.find(x => x[0] === null)) {
                                return [null]
                            }
                            return [];
                        }) as any,
                        disabled: ko.computed(() => {
                            return FilterService.hasNullEntries(self.filter.multipleCondition())
                        }),
                        onItemClick() {
                            let data = self.filter.dataSource();
                            if (data.find(x => x[0] === null)) {
                                if (!FilterService.hasNullEntries(self.filter.multipleCondition())) {
                                    self.filter.dataSource([...self.filter.dataSource().filter(x => x[0] !== null)]);
                                }
                            }
                            else {
                                self.filter.dataSource([[null, irSettings.nullText as any], ...self.filter.dataSource()]);
                            }

                            self.gridComponent.element().focus();
                        }
                    }
                }]
            },
            onInitialized(e) {
                self.gridComponent = e.component;
            },
            onSelectionChanged(eg) {
                if (updatingDataSource) {
                    updatingDataSource = false;
                    return;
                }

                if (eg.selectedRowsData.length === 0) {
                    self.filter.startDisplayCondition("All");
                }
                else if (eg.selectedRowsData.length === 1) {
                    self.filter.startDisplayCondition(eg.selectedRowsData[0][1]);
                }
                else {
                    self.filter.startDisplayCondition(eg.selectedRowsData.length === 0 || eg.selectedRowsData.length >= self.filter.dataSource().length ? "All" : `${eg.selectedRowsData.length}/${self.filter.dataSource().length}`);
                }

                if (self.filter.filterEditorType() === FilterEditorTypeEnum.ValuesCombo) {
                    let value = eg.selectedRowKeys.length > 0 ? eg.selectedRowKeys[0] : "";
                    self.filter.startCondition(value);
                    self.filter.multipleCondition(eg.selectedRowKeys.slice());
                }
                else {
                    self.filter.multipleCondition(eg.selectedRowKeys.slice());
                }

                if (self.filter.filterEditorType() === FilterEditorTypeEnum.ValuesCombo) {
                    let popover = $(componentInfo.element).closest("div.filter").data("dxPopover");
                    if (popover) {
                        popover.hide();
                    }
                }

                self.filter.publish();
            },
            onRowClick(e) {
                if (isMultiple) {
                    if (e.component.isRowSelected(e.key)) {
                        e.component.deselectRows([e.key]);
                    }
                    else {
                        e.component.selectRows([e.key], true);
                    }
                }
            },
            onContentReady(e) {
                if (self.filter.onContentReady) {
                    self.filter.onContentReady();
                }
            }
        };
        
        this.filter.clearFilter = function () {
            if (isMultiple) {
                self.filter.multipleCondition([]);

                let dataSource = self.filter.dataSource();
                if (dataSource) {
                    self.sort(dataSource);
                    self.filter.dataSource(dataSource);
                }
            }
        };

        this.filter.updateDataSource = function (this: Filter, callback: Function) {
            if (this.requireDataSourceUpdate()) {
                let widgetId = undefined;
                let containerScope = this.scope();
                if (containerScope == ContainerScopeEnum.Mapping) {
                    containerScope = ContainerScopeEnum.Workbook;
                }
                else if (containerScope == ContainerScopeEnum.Widget) {
                    widgetId = workbook.workbookConfig.selectedDashboardWidget?.id();
                }

                let data = workbook.workbookConfig.activeTab().getBaseSubmitObject();
                
                data.scope = containerScope;
                data.filterId = this.id();
                data.filterTemplateId = this.filterTemplate();
                data.widgetId = widgetId;
                data.isNewFilter = this.added();
                data.filter = this.added() ? ko.toJS(this) : null;

                let self = this;
                let o = {
                    url: urlConfigs.filters + "GetFilterDataSource",
                    data: data,
                    dataType: "json",
                    dontUpdateFilters: true
                } as RequestServerParams
                o.successFunction = function (result) {
                    self.requireDataSourceUpdate(false);

                    if (FilterService.hasNullEntries(self.multipleCondition()) && !result.dataSource.find(x => x[0] === null)) {
                        result.dataSource = [[null, irSettings.nullText as any], ...result.dataSource];
                    }

                    self.dataSource(result.dataSource);
                    self.dataSourceLength(result.dataSource ? result.dataSource.length : 0);

                    callback();
                };
                o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to get the filter data source";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                }

                irGlobal.requestServer(o);
            }
            else {
                callback();
            }
        };
    }
}